import { ApolloError, QueryResult, useQuery } from '@apollo/client';
import GET_READING_LOGS from '../../queries/books/get-reading-logs-query';
import type { ReadingLog } from '@monorepo/shared/src/graph/schema-generated-types-student';
import { StoreTypename } from 'types';

export type ReadingLogsState = {
  logs: ReadingLog[] | null;
  error: ApolloError | undefined;
  isLoading: boolean;
};
export type ReadingLogsDispatch = undefined;
export type ReadingLogs = [ReadingLogsState, ReadingLogsDispatch];

export const ReadingLogs = (): { __typename: string } => ({
  __typename: StoreTypename.READING_LOGS,
});

const useReadingLogsStore = (bookId: number): ReadingLogs => {
  const { data, loading, error }: QueryResult<{ readingLogs: ReadingLog[] | undefined }> = useQuery(
    GET_READING_LOGS,
    {
      fetchPolicy: 'no-cache',
      variables: { where: { bookId: [bookId] } },
    }
  );

  return [
    {
      logs: data?.readingLogs || null,
      error,
      isLoading: loading,
    },
    undefined,
  ];
};

export default useReadingLogsStore;
